module.exports = __webpack_public_path__ + "54cf98f5/img/SOURCERY_poweredby_web.9819842b.png";